export default "__VITE_ASSET__0ecc5ccd__"